export const API_URL_ADDRESS_STREET = (zipCode: string) => `/shop/api/fwa/lookupstreetnames?zipCode=${zipCode}`;
export const API_URL_ADDRESS_SEARCH = (zipCode: string, streetName: string) =>
    `/shop/api/fwa/lookupstreetnumbers?streetName=${streetName}&zipCode=${zipCode}`;
export const API_URL_LOOKUP_PACKAGES = "/shop/api/fwa/lookuppackages/";
export const API_URL_CHECK_AND_SAVE_ADDRESS = "/shop/api/fwa/checkandsaveaddress";
export const API_URL_ADD_PACKAGE = "/shop/api/fwa/addpackage";
export const API_URL_SAVE_CONTACT_INFO = "/shop/api/fwa/save-contact-info";
export const API_URL_SUBMIT = "/shop/api/fwa/submit";
